import type { ReactNode } from 'react'
import s from '../auth.module.css'

export function AuthShell({
  title,
  subtitle,
  steps,
  children,
  footer,
}: {
  title: ReactNode
  subtitle?: ReactNode
  steps?: { label: string; state: 'done' | 'active' | 'todo' }[]
  children: ReactNode
  footer?: ReactNode
}): ReactNode {
  /* A section, not a <main>: these screens now render inside SiteLayout,
     which already provides the page's main landmark. */
  return (
    <div className={s.page}>
      <section className={s.card}>
        <h1 className={s.title}>{title}</h1>
        {subtitle !== undefined && <p className={s.subtitle}>{subtitle}</p>}

        {steps !== undefined && (
          <ol className={s.steps}>
            {steps.map((step, index) => (
              <li
                key={step.label}
                className={[
                  s.step,
                  step.state === 'active' ? s.stepActive : '',
                  step.state === 'done' ? s.stepDone : '',
                ]
                  .filter(Boolean)
                  .join(' ')}
                aria-current={step.state === 'active' ? 'step' : undefined}
              >
                {step.state === 'done' ? '✓' : index + 1}. {step.label}
                {index < steps.length - 1 && <span aria-hidden="true"> ›</span>}
              </li>
            ))}
          </ol>
        )}

        {children}

        {footer !== undefined && <div className={s.footer}>{footer}</div>}
      </section>
    </div>
  )
}
